import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import Breadcrumbs from "@FRAMEWORK/ui/desktop/header/Breadcrumbs";
import useGlobalMenu from "@QUERIES/bff/global/useGlobalMenu";
import Link from "next/link";
import {useRouter} from "next/router";
import {useMemo} from "react";

type Crumb = {
	url: string;
	text: string;
};

type CrumbProps = {
	crumbArray?: Crumb[] /* 받은 데이터로만 생성 */;
	lastCrumb?: Crumb /* crumb 맨뒤쪽에 추가 */;
};

const BreadcrumbLender = ({crumbs}: {crumbs: Crumb[]}) => (
	<Breadcrumbs>
		{crumbs &&
			crumbs.map((item: Crumb, index) => (
				<li key={index}>
					<Link href={item.url || "#"}>
						<a>{item.text}</a>
					</Link>
				</li>
			))}
	</Breadcrumbs>
);

const BreadCrumbComponent = ({crumbArray, lastCrumb}: CrumbProps) => {
	if (crumbArray) return <BreadcrumbLender crumbs={crumbArray} />;

	const router = useRouter();
	const queryDspSid = router.query?.dspSid;
	const dspSid = `${queryDspSid.slice(0, -2)}00`;

	const globalMenu = useGlobalMenu().data?.body;
	const {menuLv1List, menuLv2List, menuLv3List} = globalMenu;
	const menuList = [...menuLv1List, ...menuLv2List, ...menuLv3List];

	const crumbs = useMemo(() => {
		const result = [];
		if (!menuList) return result;
		const lv3 = menuList.find(v => v.dspSid === dspSid);
		if (!lv3 || lv3.lv !== 3) return result;
		const lv2 = menuList.find(v => v.dspSid === lv3.dspSidHi);
		const lv1 = menuList.find(v => v.dspSid === lv2.dspSidHi);

		result.push({text: "홈", url: publicRuntimeConfig.ENV_PORTAL_URL});
		lv1 && result.push({text: lv1.dspNm, url: lv1.dspUrl || ""});
		lv2 && result.push({text: lv2.dspNm, url: lv2.dspUrl || ""});
		result.push({text: lv3.dspNm, url: lv3.dspUrl || ""});

		// 마지막 Crumb가 있는 경우 추가
		if (lastCrumb) result.push(lastCrumb);

		return result;
	}, [globalMenu]);

	return <BreadcrumbLender crumbs={crumbs} />;
};

const Breadcrumb = (props: CrumbProps) => (
	<ErrorBoundary logMsg="Breadcrumb Error">
		<BreadCrumbComponent {...props} />
	</ErrorBoundary>
);

export default Breadcrumb;
export type {Crumb};
